import { useContext, useEffect, useMemo, useState } from 'react'

import moment from 'moment'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import SmartTable, { SmartTableDataTypes } from '../../../Components/shared/SmartTable'
import { getFullAbbreviation, getFullName } from '../../../utils/entities/specialityYear'
import { LanguageLocales } from '../../../utils/constants'
import AssistantInfo from '../../../Components/MACCS/Internships/AssistantInfo'
import { faUserGraduate } from '@fortawesome/pro-solid-svg-icons'
import { getAllAssistants } from '../../../utils/api/assistant'

const InstitutionAssistantsView = () => {
  const { user } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)

  const [assistants, setAssistants] = useState([])
  const [loading, setLoading] = useState(true)
  const [selectedAssistant, setSelectedAssistant] = useState(null)

  const languages = useMemo(() => Object.values(LanguageLocales).map(locale => ({
    id: locale,
    name: t('locale_languages.' + locale)
  })), [t])

  useEffect(() => {
    if (user) {
      getAllAssistants(user).then(({ data }) => {
        const assistants = data.map(assistant => {
          assistant.specialityName = assistant.schoolSpeciality && assistant.schoolSpeciality.specialityYear
            ? assistant.schoolSpeciality.specialityYear.specialityAbbreviation
            : null

          if (assistant.birthdate) {
            assistant.birthdate = moment(assistant.birthdate).format('DD/MM/YYYY')
          }

          return assistant
        })

        setAssistants(assistants)
        setLoading(false)
      })
    }
  }, [user.id])

  const columns = [
    { type: SmartTableDataTypes.ID, key: 'id' },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Speciality'),
      key: 'specialityName',
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Financial year'),
      key: d => {
        return getFullAbbreviation(d.financialYear)
      },
      tooltipKey: d => {
        return getFullName(d.financialYear)
      },
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Lastname'),
      key: 'lastname',
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Firstname'),
      key: 'firstname',
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Language'),
      key: 'language',
      options: languages,
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Email'),
      key: 'email',
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Registration number'),
      key: 'matricule',
      isNullable: true,
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Phone'),
      key: 'phoneNumber',
      disabled: true
    },
    {
      type: SmartTableDataTypes.DATE,
      name: t('Birthdate'),
      key: 'birthdate',
      format: 'DD/MM/YYYY',
      isNullable: true,
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Gender'),
      key: 'gender',
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('Nationality'),
      key: 'nationality',
      disabled: true
    },
    {
      type: SmartTableDataTypes.STRING,
      name: t('NISS'),
      key: 'niss',
      password: true,
      disabled: true
    }
  ]

  const additionalActions = [
    {
      iconName: faUserGraduate,
      type: 'primary',
      title: t('Assistant sheet'),
      onClick: setSelectedAssistant
    }
  ]

  return (
    <>
      <SmartTable
        columns={columns}
        data={assistants}
        loading={loading}
        noDataText={t('You do not have any assistants.')}
        additionalActions={additionalActions}
      />
      <AssistantInfo
        assistant={selectedAssistant}
        onClose={() => setSelectedAssistant(null)}
      />
    </>
  )
}

export default InstitutionAssistantsView
